export const NO_LEAD_BANNER_HEIGHT = 104;
export const NO_LEAD_BANNER_HEIGHT_MOBILE = 138;
